import React, { useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Typography,
  message,
} from "antd";
import { loginApi } from "../api/ManageApi";
import GlobalLoader from "../components/GlobalLoading";
import viewUtils from "../utils/viewUtils";

const Login = () => {
  const [form] = Form.useForm();

  const handleLogin = (data: any) => {
    GlobalLoader.show();
    loginApi({
      account: data?.account,
      password: data?.password,
    }).then((res) => {
      if (res.status) {
        localStorage.setItem("admin-token", res?.data?.token);
        viewUtils.goToAdminRootPage();
      } else {
        message.error(res?.error || '登录失败')
      }
      GlobalLoader.hide();
    });
  }

  useEffect(() => {
    document.title = "和映官网后台管理登录";
  }, []);

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Form
        form={form}
        size='large'
        style={{
          background: 'white',
          width: "min(450px, 90%)",
          padding: '5%',
          textAlign: 'center'
        }}
        onFinish={handleLogin}
      >
        <Typography.Title level={3}>后台登录</Typography.Title>
        <div style={{marginBottom: '3em'}}></div>
        <Form.Item name="account" style={{width: '100%'}} rules={[{required: true, message: ''}]}>
          <Input placeholder='请输入用户名' />
        </Form.Item>
        <Form.Item name="password" style={{width: '100%'}} rules={[{required: true, message: ''}]}>
          <Input placeholder='请输入密码' type='password' />
        </Form.Item>
        <Button htmlType="submit" type='primary' style={{width: '60%', marginTop: '1em'}}>
          登录
        </Button>
      </Form>
    </div>
  );
};

export default Login;